import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Play from "./views/Play.vue";
import StartGame from "./views/StartGame.vue";
import Tutorial from "./views/Tutorial.vue";
import Summary from "./views/Summary.vue";
import Home from "./views/Home.vue";
import Hiscore from "./views/Hiscore.vue";

Vue.use(Router);

const router = new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "home",
      components: {
        header: AppHeader,
        default: Home,
        footer: AppFooter
      },
      meta: { title: 'Home' } // Add title here
    },
    {
      path: '/start-game',
      name: "startGame",
      components: {
        header: AppHeader,
        default: StartGame,
        footer: AppFooter
      },
      props: {
        default: (route) => {
          console.log("router values:", route.query.challenge, route.query.difficulty);
          return {
            difficulty: route.query.difficulty,
            challenge: route.query.challenge
          };
        },
        header: false,
        footer: false
      },
      meta: { title: 'Starting Game...' } // Add title here
    },
    {
      path: '/play',
      name: "play",
      components: {
        header: AppHeader,
        default: Play,
      },
      props: {
        default: true
      },
      meta: { title: 'Play' } // Add title here
    },
    {
      path: "/tutorial",
      name: "tutorial",
      components: {
        header: AppHeader,
        default: Tutorial,
        footer: AppFooter
      },
      meta: { title: 'Tutorial' } // Add title here
    },
    {
      path: "/hiscore",
      name: "hiscore",
      components: {
        header: AppHeader,
        default: Hiscore,
        footer: AppFooter
      },
      meta: { title: 'Hiscore' } // Add title here
    },
    {
      path: "/summary/:gameUuid",
      name: "summary",
      components: {
        header: AppHeader,
        default: Summary,
        footer: AppFooter
      },
      props: {
        default: true
      },
      meta: { title: 'Summary' } // Add title here
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  document.title = `Transfer Quiz - ${to.meta.title}` || 'Transfer Quiz';
  next();
});

router.afterEach((to) => {
  // Google Analytics page tracking
  if (typeof gtag !== "undefined") {
    gtag('config', 'G-T5F893HBQZ', {
      'page_path': to.fullPath
    });
  }
});

export default router;